import { Outlet, useLocation } from "react-router";
import { PageHeader } from "@/components/page-header";
import { Link } from "@/components/ui/link";
import { useT } from "@/lib/i18n/use-t";
import { cn } from "@/lib/utils";
import { T } from "./layout.i18n";
import { SyncButton } from "./sync-button";

export default function BillingLayout() {
  const t = useT(T);
  const { pathname } = useLocation();

  const tabs = [
    { key: "overview", href: "/settings/billing" },
    { key: "invoices", href: "/settings/billing/invoices" },
  ] as const;

  return (
    <div className="space-y-6">
      <PageHeader
        breadcrumbs={[{ label: t.settings, href: "/settings" }, { label: t.billing }]}
        title={t.billing}
        description={t.description}
        actions={<SyncButton label={t.sync} errorLabel={t.syncError} />}
      />

      <nav className="inline-flex h-auto min-h-10 max-w-full flex-wrap items-center justify-start gap-0.5 rounded-lg bg-muted p-1 text-muted-foreground">
        {tabs.map((tab) => {
          const isActive =
            tab.href === "/settings/billing"
              ? pathname === tab.href
              : pathname.startsWith(tab.href);

          return (
            <Link
              key={tab.href}
              to={tab.href}
              className={cn(
                "inline-flex h-8 items-center justify-center whitespace-nowrap rounded-md px-3 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
                isActive
                  ? "bg-card text-foreground shadow"
                  : "hover:bg-card/50 hover:text-foreground",
              )}
            >
              {t[tab.key]}
            </Link>
          );
        })}
      </nav>

      <Outlet />
    </div>
  );
}
